var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['process-content', 'process-editor', 'layout_type_1']
  }, [_c('ProcessTop', {
    attrs: {
      "readOnly": _vm.readOnly
    }
  }), !_vm.readOnly ? _c('LNBNew') : _vm._e(), _c('IssueList', {
    attrs: {
      "experimentFlag": false
    }
  }), !_vm.readOnly ? _c('Editor', {
    attrs: {
      "editKey": _vm.editKey
    }
  }) : _vm._e(), _vm.readOnly ? _c('ReadOnlyEditor') : _vm._e(), _c('SideBar'), !_vm.readOnly ? _c('DocumentOption') : _vm._e(), _vm.readOnly ? _c('ProcessReadOnlyBtmOption', {
    attrs: {
      "processType": _vm.processType
    },
    on: {
      "editProcess": _vm.editProcess
    }
  }) : _vm._e(), _vm.readOnly ? _c('ProcessReadOnlyDocumentOption', {
    attrs: {
      "apiType": `process`
    }
  }) : _vm._e(), _c('TemplatePopup'), _c('ApprovalRequestPopup')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }